import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setOtherCovers } from "../../../redux/slice/policy/savingsPolicy/savingsPolicySlice";
import { flashMessage as flash } from "../../../utils/flash";
import { removeLeadingZeros } from "../../../utils/helpers/filter";
import { otherCovers } from "../../../utils/validators/schema";
import Select from "../../form/select/Select";

const AddOtherSavingsCover = ({
  modal_id,
  editData,
  setEditData,
  selectedCovers,
}) => {
  const { covers } = useSelector((state) => state.savingsPolicy);
  const coverName = useRef();
  const close = useRef();
  const form = useRef();
  const dispatch = useDispatch();

  const [selectedOption, setSelectOption] = useState([]);
  const [ratePass, setRatePass] = useState(null);
  const [currentCovers, setCurrentCovers] = useState(null);

  const handleRateCheck = (value) => {
    if (
      parseFloat(value) >= selectedOption[0]?.minimum_rate &&
      parseFloat(value) <= selectedOption[0]?.maximum_rate
    ) {
      setRatePass(true);
    } else {
      setRatePass(false);
    }
  };

  // console.log(covers);

  const onSubmit = (values, { resetForm }) => {
    let payload = {
      ...values,
      premium: parseFloat((values?.rate * values?.sum_assured) / 100)?.toFixed(
        2
      ),
    };

    const containsPayload = selectedCovers.some(
      (cover) => cover.cover_id === payload.cover_id
    );

    if (
      (containsPayload && !editData) ||
      (editData && payload.cover_id !== editData?.cover_id && containsPayload)
    ) {
      return flash(
        "error",
        "This cover has already been added. Please choose a different cover."
      );
    }

    // If editing, remove the old row before adding the new payload

    dispatch(setOtherCovers(payload));

    form.current.reset();
    close.current.click();
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      cover_id: editData ? editData?.cover_id : "",
      rate: editData ? editData?.rate : "",
      sum_assured: editData ? editData?.sum_assured : "",
      desc: editData ? editData?.desc : "",
      premium: editData ? editData?.premium : "",
    },
    validationSchema: otherCovers,
    validate: (values) => {
      let errors = {};
      if (values.rate < selectedOption[0]?.minimum_rate) {
        errors.rate =
          "rate cannot be less than " + selectedOption[0]?.minimum_rate;
      }
      if (values.rate > selectedOption[0]?.maximum_rate) {
        errors.rate =
          "rate cannot be greater than " + selectedOption[0]?.maximum_rate;
      }

      return errors;
    },
    onSubmit,
  });

  useEffect(() => {
    if (covers?.get_other_cover?.length) {
      let selectedOption = covers?.get_other_cover?.filter(
        (item) => item.id === values?.cover_id
      );

      setSelectOption(selectedOption);
      selectedOption[0]?.id !== editData?.cover_id &&
        setFieldValue("rate", selectedOption[0]?.default_rate);
      handleRateCheck(values?.rate);
    }
  }, [values?.cover_id]);

  useEffect(() => {
    if (covers) {
      const currentCovers = editData
        ? covers?.get_other_cover
        : covers?.get_other_cover?.filter(
            (obj) => !selectedCovers?.some((cover) => cover.cover_id === obj.id)
          );

      // console.log("currentCovers", currentCovers);

      setCurrentCovers(currentCovers);
    }
  }, [covers, editData, selectedCovers]);

  return (
    <>
      <div
        className="modal fade"
        id={modal_id}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable" role="document">
          <form
            className="modal-content rounded-4 text-dark"
            onSubmit={handleSubmit}
            ref={form}
          >
            <div className="modal-header">
              <h4 className="modal-title text-primary-1" id="myLargeModalLabel">
                {editData ? "Edit Cover" : "Add Other Covered"}
                {/* Add Other Covered */}
              </h4>
              <span
                type="button"
                className=" bg-gray hover rounded-circle border-none"
                data-bs-dismiss="modal"
                aria-hidden="true"
                ref={close}
                onClick={() => {
                  setEditData(null);
                  resetForm();
                  form.current.reset();
                  coverName.current.clearValue();
                  setFieldValue("rate", "");
                }}
                style={{ padding: "0px 3px" }}
              >
                <i
                  className="mdi mdi-close text-white"
                  style={{ fontSize: "16px" }}
                ></i>
              </span>
            </div>

            <div className="modal-body">
              <div className="px-3">
                <div className="row mb-3">
                  <div className="col-md-4 text-end sm-text-end">
                    <label htmlFor="username" className={`form-label mt-1`}>
                      Cover type<span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-md-8">
                    <Select
                      onBlur={() => {
                        handleBlur({ target: { name: "cover_id" } });
                      }}
                      name="cover_id"
                      id="cover_id"
                      data={currentCovers?.map((item) => ({
                        value: item.id,
                        label: item.cover_name,
                      }))}
                      value={values?.cover_id}
                      onChange={(selectedOption) =>
                        setFieldValue("cover_id", selectedOption?.value)
                      }
                      ref={coverName}
                      isError={errors?.cover_id && touched?.cover_id}
                    />
                    {errors?.cover_id && touched?.cover_id && (
                      <p className="text-danger mb-0">{errors?.cover_id}</p>
                    )}
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-4 text-end sm-text-end">
                    <label htmlFor="username" className={`form-label mt-1`}>
                      Rate (%)
                    </label>
                  </div>
                  <div className="col-md-8">
                    <input
                      type="number"
                      id="rate"
                      name="rate"
                      value={values.rate}
                      onChange={(value) => {
                        handleChange(value);
                        handleRateCheck(value.target.value);
                      }}
                      onBlur={handleBlur}
                      className={`form-control form-control-sm no-arrows ${
                        errors?.rate && touched?.rate && "is-invalid"
                      } ${touched.rate && ratePass && "is-valid"}`}
                    />
                    {errors?.rate && touched?.rate && (
                      <span className="text-danger">{errors?.rate}</span>
                    )}
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-4 text-end sm-text-end">
                    <label htmlFor="username" className={`form-label mt-1`}>
                      Sum Assured<span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-md-8">
                    <input
                      type="number"
                      id="sum_assured"
                      name="sum_assured"
                      value={values.sum_assured}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={`form-control form-control-sm no-arrows ${
                        errors?.sum_assured &&
                        touched?.sum_assured &&
                        "is-invalid"
                      }`}
                      onInput={(e) => {
                        removeLeadingZeros(e.target.id);
                      }}
                    />
                    {errors?.sum_assured && touched?.sum_assured && (
                      <span className="text-danger">{errors?.sum_assured}</span>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4 text-end sm-text-end">
                    <label htmlFor="desc" className={`form-label mt-1`}>
                      Detail Description / Specification
                    </label>
                  </div>
                  <div className="col-md-8">
                    <textarea
                      id="desc"
                      name="desc"
                      className={`form-control form-control-sm`}
                      value={values?.desc}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer me-3 mt-4">
              <button
                type="button"
                className="btn btn-secondary btn-sm rounded-3"
                data-bs-dismiss="modal"
                onClick={() => {
                  close.current.click();
                }}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-primary btn-sm rounded-3"
              >
                {editData ? "Edit" : "Create"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddOtherSavingsCover;
